import { IconWrapper } from '../runtime';
export default IconWrapper('whiteboard_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#62676B"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#54585C"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#7E858A"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#62676B"
    }
  }), h("g", {
    "attrs": {
      "clip-path": "url(#clip0_913_634)"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6.9225 10.79L6.9225 11.4529H7.58541L11.275 7.76338L10.6121 7.10046L6.9225 10.79Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M4.03125 14.3437L8.39091 14.3437L15.0937 7.64091L10.7341 3.28125L4.03125 9.98409L4.03125 14.3437ZM10.7341 5.93339L12.4416 7.64091L7.61412 12.4684H5.9066V10.7609L10.7341 5.93339Z",
      "fill": "white"
    }
  })]), h("defs", [h("clipPath", {
    "attrs": {
      "id": "clip0_913_634"
    }
  }, [h("rect", {
    "attrs": {
      "width": "12.375",
      "height": "12.375",
      "fill": "white",
      "transform": "translate(3 3)"
    }
  })])])]);
});